import {Injectable} from '@angular/core';
import {Icontext} from '../../aggregator/interfaces';
import {isEmpty, get, cloneDeep, remove} from 'lodash';
import {AgregationService} from '../../aggregator/services';

@Injectable()
export class ContextProviderService {

  dataBindingsWithData: any = [];
  dataComposer: any = [];

  constructor(private _agregatorService: AgregationService) {
  }

  /**
   * Fetch data from
   * @param dataComposer
   */
  fetchDataFromDataBindings(dataComposer): Promise<any> {
    this.dataComposer = cloneDeep(dataComposer);
    let tempIndex = 0;
    let contextPromise = new Promise(resolve => {
      this.dataComposer.forEach((item, itemIndex) => {
        this._agregatorService.registerQuery(item['dataBindings'])
          .subscribe((primaryData: any) => {
            if (primaryData) {
              primaryData.forEach((dataItem, index) => {
                let dataBinding = get(item, `dataBindings[${index}]`);
                this.dataBindingsWithData.push({
                  data: dataItem,
                  key: item['key'],
                  dataBinding: dataBinding
                });
              });
            }
            tempIndex++;
            if(tempIndex ===  this.dataComposer.length) {
              resolve('context data resolved');
            }
          });
      });
    });
    return contextPromise;
  }

  /**
   * Add context to item
   * @param item
   * @param key
   */
  addContext(item: any, key: string) {
      const _context: Array<Icontext> = [];
      if (!isEmpty(this.dataBindingsWithData)) {
        const contextBindings = this.getContextBindingByKey(key);
        contextBindings.forEach(contextBinding => {
          let itemDataBinding = contextBinding['dataBinding'];
          let itemData = get(contextBinding['data'], get(itemDataBinding, 'referenceField'));
          if (get(itemDataBinding, 'destinationField') == 'context' || get(itemDataBinding, 'destinationField') == 'defaultContext') {
            _context.push({
              reference: itemData,
              resourceType: get(itemDataBinding, 'targetResource')
            });
          } else {
            if (get(itemDataBinding, 'destinationFieldType') === 'array') {
              if (isEmpty(item[get(itemDataBinding, 'destinationField')])) {
                item[get(itemDataBinding, 'destinationField')] = [];
              }
              item[get(itemDataBinding, 'destinationField')].push(itemData);
            } else {
              item[get(itemDataBinding, 'destinationField')] = itemData;
            }
          }
        });
        if (!isEmpty(_context)) {
          item['context'] = _context;
        }
      }
    }

  /**
   * Get context bindings by key
   * @param key
   */
  getContextBindingByKey(key) {
    return this.dataBindingsWithData.filter(item => item['key'] === key);
  }

  /**
   * Get formatted context by key
   * @param key
   */
  getFormattedContext(key) {
    let _context = [];
    const contextBindings = this.getContextBindingByKey(key);
    contextBindings.forEach(contextBinding => {
      let itemDataBinding = contextBinding['dataBinding'];
      let itemData = get(contextBinding['data'], get(itemDataBinding, 'referenceField'));
      if (get(itemDataBinding, 'destinationField') == 'context' || get(itemDataBinding, 'destinationField') == 'defaultContext') {
        _context.push({
          reference: itemData,
          resourceType: get(itemDataBinding, 'targetResource')
        });
      }
    });
    return _context;
  }

  /**
   * clear contexts
   */
  clearContexts(keys?) {
    if (keys && keys.length > 0) {
      remove(this.dataBindingsWithData, dataBindingData => {
        return keys.includes(dataBindingData['key']);
      });
    } else {
      this.dataBindingsWithData = [];
    }
  }
}
